import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { ICreateBusinessPartnerSubGroup } from './interfaces/create-business-sub-group.interface';
import BusinessPartnerGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-group/business-partner-group.entity';
import { BusinessPartnerSubGroupService } from './business-partner-sub-group.service';
import { BusinessPartnerGroupService } from '../business-partner-group/business-partner-group.service';
import { IUpdateBusinessPartnerSubGroup } from './interfaces/update-business-sub-group.interface';
import { BusinessPartnerSubGroupAttributes } from '@albatrosdeveloper/ave-models-package';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from "app/utils/method";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { BusinessPartnersFiltersComponent } from '../../filters/business-partners-filters/business-partners-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";



@Component({
  selector: 'app-business-partner-subgroup',
  standalone: true,
  templateUrl: './business-partner-sub-group.component.html',
  styleUrl: './business-partner-sub-group.component.scss',
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    NgxMatSelectSearchModule,
    FilterComponent,
    StatusFiltersComponent,
    BusinessPartnersFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
})

export class BusinessPartnerSubGroupComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;

  displayedColumns: string[] = ["name", "code", "statusId", "actions"];
  currentCreateBusinessPartnerSubGroup: ICreateBusinessPartnerSubGroup = this.initializeCreateBusinessPartnerSubGroup();
  currentUpdateBusinessPartnerSubGroup: BusinessPartnerSubGroupAttributes | undefined;

  groupList: BusinessPartnerGroupAttributes[] = [];
  listFilterGroupList: BusinessPartnerGroupAttributes[] = [];
  searchGroup = ''
  selectedGroup = [] //filter

  dataSource: BusinessPartnerSubGroupAttributes[] = [];
  searchQuery = '';
  totalItems = 0;
  pageSize = 50;
  pageIndex = 0;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  //BUSCADOR
  searchSubscription: Subscription;
  selectedStatuses: number[] = [];
  form: FormGroup

  // Lazy loading flags
  loadFiltersData = false;
  private groupsLoaded = false;

  constructor(
    private readonly businessgroupService: BusinessPartnerSubGroupService,
    private readonly groupService: BusinessPartnerGroupService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      // companyId:[],
      businessPartnerGroupId: []
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private initializeCreateBusinessPartnerSubGroup(): ICreateBusinessPartnerSubGroup {
    return { name: "", groupId: "" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.findAllWithCount();
  }

  private fetchGroup(): void {
    this.groupService.findToComboBox().subscribe((res) => {
      this.groupList = res.data;
      this.listFilterGroupList = this.groupList.slice();
      this.groupsLoaded = true;
    });
  }

  changeOptionsGroup(event): void {
    if (!this.groupList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterGroupList = this.groupList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterGroupList = this.groupList.filter(item => item.name.toLowerCase().indexOf(search) > -1)
  }

  clearFilters() {
    this.selectedGroup = [];
    this.selectedStatuses = []; //limpiar los estados seleccionados
    this.searchQuery = "";
    this.form.reset({
      businessPartnerGroupId: null
    });
    this.paginator.pageIndex = 0; // Resetear a la primera página
    this.findAllWithCount();
  }

  findAllWithCount(): void {
    const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";

    let filter: IFilters = {
      // companyId: this.form.get("companyId")?.value,
      businessPartnerGroupId: this.form.get("businessPartnerGroupId")?.value,
      status: this.selectedStatuses.length ? this.selectedStatuses : null
    }

    this.businessgroupService
      .findAllWithCount(
        { currentPage: pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof BusinessPartnerSubGroupAttributes {
    const validSortFields: (keyof BusinessPartnerSubGroupAttributes)[] = ["id", "name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof BusinessPartnerSubGroupAttributes) ? (this.sort.active as keyof BusinessPartnerSubGroupAttributes) : "id";
  }



  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: BusinessPartnerSubGroupAttributes): string {
    return item._id.toString();
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  private ensureGroupsLoaded(): void {
    if (!this.groupsLoaded) {
      this.fetchGroup();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureGroupsLoaded();
  }

  openCreateModal(): void {
    this.ensureGroupsLoaded();
    this.currentCreateBusinessPartnerSubGroup = this.initializeCreateBusinessPartnerSubGroup();
    this.dialogRefAdd = this.dialog.open(this.addModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createBusinessPartnerSubGroup());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(materialBrand: BusinessPartnerSubGroupAttributes): void {
    this.ensureGroupsLoaded();
    this.currentUpdateBusinessPartnerSubGroup = { ...materialBrand };
    this.dialogRefEdit = this.dialog.open(this.editModal, { panelClass: "form-modal", disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateBusinessPartnerSubGroup(materialBrand._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createBusinessPartnerSubGroup(): void {
    this.businessgroupService.create(this.currentCreateBusinessPartnerSubGroup).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateBusinessPartnerSubGroup(id: string): void {
    if (this.currentUpdateBusinessPartnerSubGroup) {
      const updatedBusinessPartnerSubGroup: IUpdateBusinessPartnerSubGroup = {
        groupId: this.currentUpdateBusinessPartnerSubGroup.group._id.toString(),
        ...this.currentUpdateBusinessPartnerSubGroup
      };

      this.businessgroupService.update(id, updatedBusinessPartnerSubGroup).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close()
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, materialBrand: BusinessPartnerSubGroupAttributes): void {
    const originalStatusId = materialBrand.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerSubGroup = { ...materialBrand, statusId: updatedStatusId };

    this.businessgroupService.update(materialBrand._id.toString(), updatedBusinessPartnerSubGroup).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        materialBrand.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(materialBrand: BusinessPartnerSubGroupAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: materialBrand, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(materialBrand._id.toString()));
  }

  delete(id: string): void {
    this.businessgroupService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}

